import { Component, Signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../../services/ssession.service';
import { ServiceListItem } from '../../../services/service.common.model';
import { AlertComponent } from '../../../common/alert/alert.component';

@Component({
  selector: 'app-application-info-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    CommonModule,
    RouterModule,
    AlertComponent
  ],
  templateUrl: './application-info-page.component.html'
})
export class ApplicationInfoPageComponent {

  public applicationInfo: Signal<ServiceListItem | undefined> = toSignal((this.route.data as any).pipe(map((v: { applicationInfo: ServiceListItem | null }) => v.applicationInfo)));

  public authed: boolean = SessionService.Authed();

  public completedData: boolean = !!SessionService.GetTokenData()?.email;

  constructor(private route: ActivatedRoute) {
  }
}
